import { FC } from "react";
import { useSelector } from "react-redux";

import { SettingsTable as Table } from "components/settings-table";
import { useAgentFlag } from "hooks/use-agent-flag";
import { useDefaultInbox } from "hooks/use-default-inbox";
import { selectAreMailboxesSetUp } from "store/entities/email-domains";
import { selectMailboxesAlphabetically } from "store/entities/mailboxes/selectors";

import { ForwardingAddressEntry } from "./ForwardingAddressEntry";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
interface ForwardingListProps {
  onShowInstructions: (inboxAddress: string) => void;
  onDeleteInbox: (inboxId: string) => void;
  onEditInbox: (inboxId: string) => void;
}

export const ForwardingAddressList: FC<ForwardingListProps> = ({ onShowInstructions, onDeleteInbox, onEditInbox }) => {
  const inboxes = useSelector(selectMailboxesAlphabetically);
  const isForwardingSetUp = useSelector(selectAreMailboxesSetUp);
  const defaultInbox = useDefaultInbox();

  const [hasClosedInstructionsTooltip] = useAgentFlag("hasClosedForwardingInstructionsTooltip");

  const shouldShowInstructionsTooltip = !isForwardingSetUp && !hasClosedInstructionsTooltip;

  return (
    <Table
      columns={3}
      marginTop="0"
      marginBottom="0"
      columnSizes="4fr 3fr 4fr"
      headers={["Forwarding address", "Assigned to", "Status"]}
    >
      {inboxes // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .sort((a: any, b: any) => ((a.updatedAt ?? 0) < (b.updatedAt ?? 0) ? 1 : -1)) // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .map((inbox: any, idx: any) => (
          <ForwardingAddressEntry
            key={inbox.id}
            inbox={inbox}
            onShowInstructions={onShowInstructions}
            onDeleteInbox={onDeleteInbox}
            onEditInbox={onEditInbox}
            tooltipShown={shouldShowInstructionsTooltip && idx === inboxes.length - 1}
          />
        ))}
      <ForwardingAddressEntry
        inbox={defaultInbox}
        onShowInstructions={onShowInstructions}
        onDeleteInbox={onDeleteInbox}
        onEditInbox={onEditInbox}
        isDefault
      />
    </Table>
  );
};
